import { motion } from "framer-motion";

export const easeOut = [0.16, 1, 0.3, 1];

// Generic scroll reveal — fades & slides up when it enters the viewport.
export function Reveal({ children, delay = 0, y = 28, className = "", ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: easeOut }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

// Masked line — text slides up from behind an overflow-hidden mask.
export function MaskLine({ children, delay = 0, className = "" }) {
  return (
    <span className="reveal-mask">
      <motion.span
        className={`block ${className}`}
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1.05, delay, ease: easeOut }}
      >
        {children}
      </motion.span>
    </span>
  );
}
